import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/** Standalone-site article route: wraps <ee-help-article>, wiring its [back] to the router. */
@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  standalone: false,
})
export class ArticleComponent implements OnInit {
  slug = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.slug = params.get('slug') ?? '';
    });
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
